import { render, staticRenderFns } from "./lpsflist.vue?vue&type=template&id=296d3b22&"
import script from "./lpsflist.vue?vue&type=script&lang=js&"
export * from "./lpsflist.vue?vue&type=script&lang=js&"
import style0 from "./lpsflist.vue?vue&type=style&index=0&id=296d3b22&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports